import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientListComponent } from './client-list/client-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { ClientSearchComponent } from './client-search/client-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ClientNoteComponent } from './client-note/client-note.component';
import { ClientUserManagementComponent } from './client-user-management/client-user-management.component';
import { ClientUserInviteModalComponent } from './client-user-invite-modal/client-user-invite-modal.component';
import { ClientUserSearchComponent } from './client-user-search/client-user-search.component';
import { NgSharedLibraryModule } from '../../ng-shared-library.module';
import { PermissionsListComponent } from './permissions-list/permissions-list.component';

@NgModule({
  declarations: [
    ClientListComponent,
    ClientSearchComponent,
    ClientNoteComponent,
    ClientUserManagementComponent,
    ClientUserInviteModalComponent,
    ClientUserSearchComponent,
    PermissionsListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxMaskDirective,
    NgxMaskPipe,
    RouterModule,
    NgSharedLibraryModule,
    ReactiveFormsModule
  ],
  providers: [provideNgxMask()],
  exports: [ClientUserManagementComponent]
})
export class ClientModule {}
